export default "__VITE_ASSET__B$mgP100__"